import { render, staticRenderFns } from "./ButtonCorrection.vue?vue&type=template&id=d17233b6"
import script from "./ButtonCorrection.vue?vue&type=script&lang=js"
export * from "./ButtonCorrection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports